import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';

export interface OnboardingStepperBtnDismissSignature {
  Args: {
    onDismiss: (event: MouseEvent) => void;
  };
}

export default <template>
  <button
    type="button"
    class="btn btn--small btn--outline btn--cancel float-right ml-4"
    {{on "click" @onDismiss}}
    data-test-dismiss
  >
    <span aria-hidden="true">&times;</span>
    <span class="sr-only">close</span>
  </button>
</template> satisfies TOC<OnboardingStepperBtnDismissSignature>;
